import './DropdownMenu.scss';

export const ButtonsList = ({itemsList, onClick}) => {
  return (
    <ul className='dropdown-menu-sorting-order'>
      {itemsList.map(item => {
        return(
          <li
            key={`sort_${item.name}`}
            className='dropdown-menu-button-item'
          >
            <button
              type='button'
              onClick={() => onClick(item.value)}
            >
              {item.icon && <span>{item.icon}</span>}
              <span>{item.name}</span>
            </button>
          </li>
        )
      })}
    </ul>
  )
}
